export default __webpack_public_path__ + "static/media/productHowItWorks2.37ff708d.svg";